module.exports = __webpack_public_path__ + "img/sunset-1.724d9d55.jpg";